import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function MethodIntro() {
  return <section className="py-16 px-4 bg-slate-900 text-white" data-id="element-81">
      <div className="max-w-4xl mx-auto" data-id="element-82">
        <div className="text-center mb-12" data-id="element-83">
          <span className="text-5xl mb-6 block" data-id="element-84">💡</span>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-85">
            Presentamos el MÉTODO CALMA®
          </h2>
          <p className="text-xl md:text-2xl text-slate-300 font-medium max-w-2xl mx-auto" data-id="element-86">
            Un sistema completo de guías prácticas diseñado para madres reales,
            en situaciones reales.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-87">
          <div className="bg-slate-800/50 rounded-2xl p-8 border border-slate-700" data-id="element-88">
            <h3 className="text-xl font-bold text-slate-400 mb-6 uppercase tracking-wider" data-id="element-89">
              Lo que NO es:
            </h3>
            <ul className="space-y-4" data-id="element-90">
              <li className="flex items-start gap-3" data-id="element-91">
                <XIcon className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-92" />
                <span className="text-slate-300" data-id="element-93">
                  No es un libro de teoría que nunca vas a terminar.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-94">
                <XIcon className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-95" />
                <span className="text-slate-300" data-id="element-96">
                  No es un podcast de 40 minutos que no tenés tiempo de
                  escuchar.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-97">
                <XIcon className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-98" />
                <span className="text-slate-300" data-id="element-99">
                  No es otro consejo de "respirá profundo" que ya sabés y no te
                  alcanza.
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-green-900/20 rounded-2xl p-8 border border-green-500/30 relative overflow-hidden" data-id="element-100">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 blur-3xl rounded-full" data-id="element-101" />
            <h3 className="text-xl font-bold text-green-400 mb-6 uppercase tracking-wider" data-id="element-102">
              Lo que SÍ es:
            </h3>
            <div className="flex items-start gap-3" data-id="element-103">
              <CheckIcon className="w-8 h-8 text-green-400 flex-shrink-0 mt-1" data-id="element-104" />
              <p className="text-xl font-bold text-white leading-relaxed" data-id="element-105">
                Es un sistema de herramientas concretas, cortas y aplicables en
                el momento exacto en que las necesitás.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center max-w-3xl mx-auto" data-id="element-106">
          <p className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-107">
            Desde cómo manejar una rabieta sin perder la cabeza, hasta cómo
            poner límites sin que se convierta en una guerra. Desde entender qué
            siente tu hijo cuando no puede explicarlo, hasta recuperar tu propia
            calma después de un día devastador.
          </p>
          <div className="inline-block bg-yellow-500 text-slate-900 font-black text-xl md:text-2xl px-8 py-4 rounded-xl shadow-[0_0_30px_rgba(234,179,8,0.3)]" data-id="element-108">
            Todo en un megapack de 6 guías + 4 bonos que podés empezar a usar
            hoy mismo.
          </div>
        </div>
      </div>
    </section>;
}